import React, { Component, useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function Protected(props) {
  const Cmp = props.Cmp;
  const history = useHistory();
  useEffect(() => {
    const itemStr = localStorage.getItem("userData");
    if (!itemStr) {
      history.push("/login");
    }
  }, []);

  return (
  <div>
      <Cmp />
  </div>
  )
}
